import { render, staticRenderFns } from "./SettingBase.vue?vue&type=template&id=77e4a47e&"
import script from "./SettingBase.vue?vue&type=script&lang=ts&"
export * from "./SettingBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports